import { render, staticRenderFns } from "./UpdateConfigs.vue?vue&type=template&id=218018be&scoped=true"
import script from "./UpdateConfigs.vue?vue&type=script&lang=js"
export * from "./UpdateConfigs.vue?vue&type=script&lang=js"
import style0 from "./UpdateConfigs.vue?vue&type=style&index=0&id=218018be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218018be",
  null
  
)

export default component.exports